module.exports = __webpack_public_path__ + "img/avatar-small.0a0710a5.svg";